import './style.css';

function ProductDetail({item}){
    console.log(item);
    return <div className="product-detail-wrapper">
        <div className="product-detail">
            <h1>{item.title}</h1>
            {item.description && <p>{item.description}</p>}
            <ul className="product-detail-list">
                {item.list.map(i => <li>{i}</li>)}
            </ul>
        </div>
        <img src={item.imageDetail}/>    
    </div>  
}

export default ProductDetail;